import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './WineryProducts.css'; 
import prodictpagelogo from "../assets/images/prodictpagelogo.svg";
import Bio from './WineryProductsItems/Bio';
import Bio_bordo_3 from '../assets/images/Bio_bordo_3.png';
import Clarifiers from './WineryProductsItems/Clarifiers'
import CHIARIFICANTI_bordo_3 from '../assets/images/CHIARIFICANTI_bordo_3.png'
import Enzymes from './WineryProductsItems/Enzymes'
import Enzimi_bordo_4 from '../assets/images/Enzimi_bordo_4.png'
import OakAlternatives from './WineryProductsItems/OakAlternatives'
import OakAlternativesimg from '../assets/images/oak_alternative_bg_removed.png'
import PostFermentationDevelopment from './WineryProductsItems/PostFermentationDevelopment'
import Postfermentationddevimg from '../assets/images/Postfermentationddev.png'
import Tannins from './WineryProductsItems/Tannins'
import Tanninsimg from '../assets/images/tanninibordo.png'
import Yeast from './WineryProductsItems/Yeast'
import Yeastimg from '../assets/images/Yeast.png'
import YeastNutrients from './WineryProductsItems/YeastNutrients'
import YeastNutrientsimg from '../assets/images/YeastNutrients.png'
import LanguageSwitcher from '../LanguageSwitcher';

export const products = [
  { id: 1, name: 'BIO Products',  images: [Bio_bordo_3] },
  { id: 2, name: 'Clarifiers',  images: [CHIARIFICANTI_bordo_3] },
  { id: 3, name: 'Enzymes',  images: [Enzimi_bordo_4] },
  { id: 4, name: 'Oak Alternatives', images: [OakAlternativesimg] },
  { id: 5, name: 'Post Fermentation Development', images: [Postfermentationddevimg] },
  { id: 6, name: 'Tannins',  images: [Tanninsimg] },
  { id: 7, name: 'Yeast',  images: [Yeastimg] },
  { id: 8, name: 'Yeast Nutrients',  images: [YeastNutrientsimg] },
];

const componentMap = {
  'BIO Products': Bio,
  'Clarifiers': Clarifiers ,
  'Enzymes': Enzymes,
  'Oak Alternatives': OakAlternatives,
  'Post Fermentation Development': PostFermentationDevelopment,
  'Tannins': Tannins,
  'Yeast': Yeast,
  'Yeast Nutrients': YeastNutrients,
};

const WineryProducts = () => {
  const { t } = useTranslation();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const location = useLocation();

  useEffect(() => {
    if (location.state?.WineryProducts) {
      const product = products.find(p => p.name === location.state.WineryProducts);
      if (product) {
        setSelectedProduct(product);
        window.scrollTo({ top: 0, behavior: 'smooth' }); 
      }
    }
  }, [location.state]);

  const handleProductClick = (product) => {
    setSelectedProduct(product);
    window.scrollTo({ top: 0, behavior: 'smooth' }); 
  };

  const SelectedComponent = selectedProduct ? componentMap[selectedProduct.name] : null;

  return (
    <div className='winery-main-Product'>
        <LanguageSwitcher id="winery-sidebar" />
      <div className='winery-main-Product1'>
        <Link to="/" className='winery-logolink'>
          <img src={prodictpagelogo} alt="Product Page Logo" />
        </Link>  
      </div>

      {SelectedComponent && <SelectedComponent product={selectedProduct} />}

      <div className="winery-Other-products">
        <h1>{t('Other Products')}</h1> 
        <div className="winery-grid-container">
          {products.map((product) => (
            <div key={product.id} className="winery-product-item" onClick={() => handleProductClick(product)}>
              <h1>{t(product.name)}</h1> 
              <img src={product.images[0]} alt={product.name} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default WineryProducts;